import type { Underlying } from 'models/underlying';
import type { CommodityUnderlying } from 'models/underlying/commodity';
import type { CreditUnderlying } from 'models/underlying/credit';
import type { EquityUnderlying } from 'models/underlying/equity';
import type { ForexUnderlying } from 'models/underlying/forex';
import type { RateUnderlying } from 'models/underlying/rate';

export const isCommodityUnderlying = (underlying: Underlying): underlying is CommodityUnderlying => {
  return underlying.asset === 'Commodity';
};

export const isCreditUnderlying = (underlying: Underlying): underlying is CreditUnderlying => {
  return underlying.asset === 'CreditRate';
};

export const isEquityUnderlying = (underlying: Underlying): underlying is EquityUnderlying => {
  return underlying.asset === 'Equity';
};

export const isForexUnderlying = (underlying: Underlying): underlying is ForexUnderlying => {
  return underlying.asset === 'Forex';
};

export const isRateUnderlying = (underlying: Underlying): underlying is RateUnderlying => {
  return underlying.asset === 'Rate';
};
